import { Button, Intent, TextArea } from '@blueprintjs/core';
import React from 'react';
import { patchTripNotes } from "../../services/tripApiService";
import { editActions, editButtons, notesArea, marginNotesScroll } from '../../styles';
import { AppToaster } from "../../toastComponent";
import { formatValue } from '../../../utils/helpers'
import { ERROR_TOAST_ICON } from '../../../utils/Constants';

export default class TripNotesPanel extends React.Component {

	state = {
		editInternal: false,
		editDriver: false,
		notes: '',
		driverNotes: '',
		savedNotes: '',
		savedDriverNotes: '',
		loading: false
	}

	componentDidUpdate(prevProps) {
		if (this.props.trip !== null && prevProps.trip?.tripNumber !== this.props.trip.tripNumber) {
			this.setState({
				notes: this.props.trip?.notes,
				driverNotes: this.props.trip?.driverNotes,
				savedNotes: '',
				savedDriverNotes: ''
			})

			localStorage.removeItem("savedNotes");
			localStorage.removeItem("savedDriverNotes");
		}
	}


	componentDidMount() {
		this.setState({
			notes: localStorage.getItem("savedNotes") ? localStorage.getItem("savedNotes") : this.props.trip?.notes,
			driverNotes: localStorage.getItem("savedDriverNotes") ? localStorage.getItem("savedDriverNotes") : this.props.trip?.driverNotes
		})
	}

	updateWindowDimensions = () => {
		this.setState({ height: window.innerHeight });
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		localStorage.removeItem("savedNotes");
		localStorage.removeItem("savedDriverNotes");
	}

	handleSave = async () => {
		const data = { tripId: this.props.trip.tripNumber, notes: this.state.notes, driverNotes: this.state.driverNotes, intent: 'OverrideNotes' };
		Object.keys(data).forEach(key => data[key] == null && delete data[key]);
		this.setState({ loading: true });
		try {
			await patchTripNotes(data);
			AppToaster.show({ message: "Note saved successfully.", intent: "primary", icon: 'tick', });
			this.setState(state => ({
				editInternal: false,
				editDriver: false,
				savedNotes: state.notes,
				savedDriverNotes: state.driverNotes,
				loading: false
			}));
			localStorage.setItem("savedNotes", this.state.savedNotes);
			localStorage.setItem("savedDriverNotes", this.state.savedDriverNotes);
		}
		catch (error) {
			console.log(error);
			AppToaster.show({ message: "There was an error saving notes. Please try again.", intent: "danger", icon: ERROR_TOAST_ICON, });
			this.setState({ loading: false });
		}
	}

	handleEdit = (e) => {
		if (e.currentTarget.id.includes("internal")) {
			this.setState((state) => ({ editInternal: !state.editInternal }))
		} else {
			this.setState((state) => ({ editDriver: !state.editDriver }))
		}
	}

	handleNotes = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	}

	handleCancel = (e) => {
		this.setState(state => ({
			notes: state.savedNotes ? state.savedNotes : this.props.trip?.notes,
			driverNotes: state.savedDriverNotes ? state.savedDriverNotes : this.props.trip?.driverNotes
		}));
		this.handleEdit(e);
	}

	render() {
		return (
			<div>
				<div>
					<div style={editActions}>
						<h3>Internal Notes</h3>
						{this.state.editInternal ?
							<div>
								<Button id="save-internal" loading={this.state.loading} intent={Intent.SUCCESS} style={editButtons} onClick={this.handleSave} text="Save" />
								<Button id="cancel-internal" intent={Intent.DANGER} style={editButtons} onClick={(e) => this.handleCancel(e)} text="Cancel" />
							</div>
							: <div>
								<Button
									id="edit-internal"
									disabled={this.state.editDriver || !this.props.trip}
									intent={Intent.PRIMARY}
									style={editButtons}
									onClick={(e) => this.handleEdit(e)}
									text="Edit"
								/>
							</div>}
					</div>
					<div style={marginNotesScroll}>
						<TextArea style={notesArea} className="custom-notes bp3-fill" growVertically={true}
							name="notes"
							onChange={(e) => this.handleNotes(e)}
							disabled={!this.state.editInternal || this.state.editDriver || !this.props.trip} large={true}
							value={formatValue(this.state.notes)} />
					</div>
				</div>
				<div>
					<div style={editActions}>
						<h3>Driver Notes</h3>
						{this.state.editDriver ?
							<div>
								<Button
									name="save-driver"
									loading={this.state.loading}
									intent={Intent.SUCCESS}
									style={editButtons}
									onClick={this.handleSave}
									text="Save"
								/>
								<Button
									name="cancel-driver"
									intent={Intent.DANGER}
									style={editButtons}
									onClick={(e) => this.handleCancel(e)}
									text="Cancel"
								/>
							</div>
							: <div>
								<Button
									id="edit-driver"
									disabled={this.state.editInternal || !this.props.trip}
									intent={Intent.PRIMARY}
									style={editButtons}
									onClick={(e) => this.handleEdit(e)}
									text="Edit"
								/>
							</div>}
					</div>
					<div style={marginNotesScroll}>
						<TextArea style={notesArea}
							name="driverNotes"
							onChange={(e) => this.handleNotes(e)}
							className="custom-notes bp3-fill " growVertically={true}
							disabled={!this.state.editDriver || this.state.editInternal || !this.props.trip}
							large={true} value={formatValue(this.state.driverNotes)} />
					</div>
				</div>
			</div>
		)
	}
}
